import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../images/image_empty_error.png';

export default function EmailExport({ event, menhirUrl }) {
    return (
        <div>
            <WeezHeader title={<Trans i18nKey="ticket.email_export.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={<Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={`${menhirUrl}/communiquer_marketing_data.php?id_evenement=${event.id}`} />}
            />
        </div>
    );
}

EmailExport.propTypes = {
    event: PropTypes.object.isRequired,
    menhirUrl: PropTypes.string.isRequired
};
